import { Box, Typography } from "@mui/material";

export const PreparationComponent = () => {
  return (
    <Box sx={{ textAlign: "center" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          padding: 2,
          mt: "4rem",
        }}
      >
        <img
          src="/img/capital_bot.png"
          alt="Capital Bot"
          style={{
            width: "200px",
            height: "200px",
            maxWidth: "50%",
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      </Box>{" "}
      <Typography variant="body1">チャットの準備をしています…</Typography>
      <Typography variant="body1">もう少々お待ちください</Typography>
    </Box>
  );
};
